import {HttpHeaders} from "@angular/common/http";

export class UrlDto {

  private readonly url: URL;
  private readonly headers: HttpHeaders;

  constructor(url: URL, headers: HttpHeaders) {
    this.url = url;
    this.headers = headers;
  }

  public getUrl(): string {
    return this.url.toString();
  }

  public getHeaders(): HttpHeaders {
    return this.headers;
  }

  public getOptions(): { headers?: HttpHeaders } {
    return {headers: this.getHeaders()};
  }
}
